/**
 * @author Jorge Casas
 * @creationDate 22/04/2024
 */

import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

/**
 * @function AssetFormCustomsDocuments
 * 
 * @param {Object} props
 * @param {Object} props.errors
 * @param {Function} props.handleValueChange
 * @param {Function} props.handleFileChange
 * @param {Function} props.handleClick
 * @param {Object} props.hiddenFileInput
 * @param {Array} props.files
 * @param {Boolean} props.isSubmitted
 * @param {Function} props.t
 * @param {Object} props.values
 * @param {Array} props.name
 * @returns {React.Component}
 */
const AssetFormCustomsDocuments = ({
  catalogs = {},
  errors = {},
  handleValueChange = () => {},
  handleFileChange = () => {},
  handleClick = () =>{},
  hiddenFileInput,
  files,
  isSubmitted = false,
  t = () => {},
  values = {},
  name,
  isLoading = false,
}) => {
  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.customs_documents_title')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.customsDocumentsPedimentoNumber) || {}}
          name={'customsDocumentsPedimentoNumber'}
          label={t('assets.fields.customs_documents_pedimento_number')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsPedimentoNumber}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.customsDocumentsPedimentoKey) || {}}
          name={'customsDocumentsPedimentoKey'}
          label={t('assets.fields.customs_documents_pedimento_key')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsPedimentoKey}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.customsDocumentsCustomsKey) || {}}
          name={'customsDocumentsCustomsKey'}
          label={t('assets.fields.customs_documents_customs_key')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsCustomsKey}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldDate
          error={(isSubmitted && errors.customsDocumentsDate) || {}}
          name={'customsDocumentsDate'}
          label={t('assets.fields.customs_documents_date')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsDate}
        />
      </div>
      <br />
      <br />
      <br />
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._customsDocuments) || {}}
          isLoading={isLoading}
          name={'customsDocumentsStatus'}
          label={t('catalog.customs_documents_status.name')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsStatus}
        >
          {catalogs.customsDocumentsStatus &&
            catalogs.customsDocumentsStatus
              .filter((element) => element != null)
              .map((element) => (
                <option value={element.id} key={element.id}>
                  {t(element.value)}
                </option>
              ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.customsDocumentsImport) || {}}
          name={'customsDocumentsImport'}
          label={t('assets.fields.customs_documents_import')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsImport}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.customsDocumentsQuantity) || {}}
          name={'customsDocumentsQuantity'}
          label={t('assets.fields.customs_documents_quantity')}
          handleChange={handleValueChange}
          t={t}
          value={values.customsDocumentsQuantity}
        />
      </div>
      <div className="d-flex col-sm-8 col-md-6 col-lg-6" style={{alignItems:'center'}}>
        <button type='button' className="col-g btn btn-info ml-4 mr-4" onClick={handleClick}>
          {t('assets.fields.customs_documents_upload_files')}
        </button>
        <input
          type='file'
          id='files'
          value={files}
          onChange={handleFileChange}
          name={'files'}
          ref={hiddenFileInput}
          style={{display: 'none'}}
        />
        {name && name.map(file => <div style={{marginLeft:'3px', marginRight: '3px'}}>{file.name}</div>)}
      </div>
      <br />
      <br />
      <br />
    </div>
  );
};

export default translate()(AssetFormCustomsDocuments);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetFormCustomsDocuments.js